(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ultreia-cart-drawer"] && !Shopify.designMode) return;
  try {
    /* Cart drawer runtime. The drawer's contents render server-side on load; this
     keeps them live with JS on. Reuses the header's generic open/close (this is a
     [data-ultreia-drawer]); only the cart logic lives here:
       · stepper / remove → POST /cart/change.js → re-render the drawer body
       · listen for ultreia:cart:change (cart page, quick-shop, add-to-cart) so the
         drawer refreshes when items change elsewhere
       · the bag's [data-cart-open] trigger is wired by the header. */
  /* "¿Ya resolviste qué vas a comer?" strip (drawer + /cart page). Touch and
     trackpad swipe are native overflow scrolling; this adds the ‹ › buttons (one
     card-width per press, disabled at either end) and click-and-drag for a mouse.
     Global so the cart page can re-bind after its own re-renders; tracks are
     marked once bound, so calling it again on the same scope is harmless. */
  window.ultreiaFoodStrip = function (scope) {
    (scope || document).querySelectorAll('[data-food-track]:not([data-food-bound])').forEach(function (track) {
      track.setAttribute('data-food-bound', '');
      var strip = track.closest('.u-cdfood');
      var nav = strip && strip.querySelector('.u-cdfood__nav');
      var prev = strip && strip.querySelector('[data-food-prev]');
      var next = strip && strip.querySelector('[data-food-next]');

      function step() {
        var card = track.querySelector('.u-cdfood__card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.offsetWidth + gap : 146;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        if (nav) {
          if (max <= 1) nav.setAttribute('data-idle', '');
          else nav.removeAttribute('data-idle');
        }
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= max - 1;
      }
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      // The drawer may still be closed (zero width) when this runs; re-check
      // once it's laid out.
      requestAnimationFrame(sync);

      var startX = 0, startLeft = 0, dragging = false, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest('button')) return;
        dragging = true; moved = false;
        startX = e.clientX; startLeft = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(e.pointerId);
        }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        if (!moved) return;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(e.pointerId)) track.releasePointerCapture(e.pointerId);
        // Land on the nearest card instead of wherever the drag let go.
        var s = step();
        track.scrollTo({ left: Math.round(track.scrollLeft / s) * s, behavior: reduce ? 'auto' : 'smooth' });
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      // A drag that ends over a card link must not also open the product.
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  };
  window.ultreiaFoodStrip(document);

  (function () {
    document.querySelectorAll('[data-ultreia-cart-drawer]').forEach(function (drawer) {
      if (drawer.dataset.cartInit) return;
      drawer.dataset.cartInit = '1';

      var I18N = {};
      try { I18N = JSON.parse(drawer.getAttribute('data-i18n') || '{}'); } catch (e) {}

      var changeUrl = drawer.getAttribute('data-change-url');
      var cartUrl = drawer.getAttribute('data-cart-url');
      var recsUrl = drawer.getAttribute('data-recs-url');
      var live = drawer.querySelector('[data-cart-live]');
      if (!live) return;
      var busy = false;
      // Remembers the seed we last fetched recommendations for, so re-renders that
      // don't change the seed (e.g. a quantity tweak) don't refetch the same strip.
      var recsSeed = null;

      // Mark fresh <img>s loaded so the fade-in fires (cached images may already be
      // complete before a load listener would attach).
      function bindImages(scope) {
        scope.querySelectorAll('.u-cdrow__img img').forEach(function (img) {
          if (img.complete && img.naturalWidth) { img.classList.add('is-loaded'); return; }
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
        });
      }

      // Carry an already-rendered recommendations strip across a body swap. The recs
      // host lives inside [data-cart-body], so a wholesale re-render blanks it; we keep
      // the existing strip's markup in the fresh host so it never collapses to empty.
      // When the seed is unchanged loadRecs() leaves it as-is (no flicker on a quantity
      // tweak); when the seed changed (e.g. the first line was removed) loadRecs() swaps
      // in the new strip in one shot once it arrives — the old strip stays visible in
      // the meantime instead of vanishing first. `freshBody` is the parsed
      // [data-cart-body] element about to be injected.
      function preserveRecs(freshBody) {
        if (!freshBody) return;
        var oldHost = live.querySelector('[data-cart-recs-host]');
        var newHost = freshBody.querySelector('[data-cart-recs-host]');
        if (!oldHost || !newHost || !oldHost.querySelector('.u-cdrec')) return;
        newHost.innerHTML = oldHost.innerHTML;
      }

      // After a body swap the progress card arrives already at its new value; start
      // its bar + backpack level at the old value and let the CSS transitions carry
      // them across, with a little squash of the backpack. `prev` is the card's
      // data-pct from before the swap (null when there was no card).
      function animateProgress(prev) {
        var card = live.querySelector('[data-cart-progress]');
        if (!card || prev == null) return;
        var next = card.getAttribute('data-pct');
        if (next === prev) return;
        var fill = card.querySelector('[data-progress-fill]');
        var level = card.querySelector('[data-backpack-level]');
        if (fill) fill.style.width = prev + '%';
        if (level) level.style.bottom = prev + '%';
        void card.offsetWidth;
        requestAnimationFrame(function () {
          if (fill) fill.style.width = next + '%';
          if (level) level.style.bottom = next + '%';
          card.classList.add('is-bump');
        });
      }

      // The food strip scrolls sideways; a body swap would snap it back to the
      // first card right after the shopper adds one further along.
      function foodScroll() {
        var t = live.querySelector('[data-food-track]');
        return t ? t.scrollLeft : 0;
      }
      // Same for the drawer's own vertical scroll: the fresh body would open at
      // the top, jumping away from the row the shopper just changed.
      function listScroll() {
        var el = live.querySelector('.u-cartdrawer__scroll');
        return el ? el.scrollTop : 0;
      }
      function restoreListScroll(y) {
        var el = live.querySelector('.u-cartdrawer__scroll');
        if (el && y) el.scrollTop = y;
      }
      function restoreFoodScroll(x) {
        var t = live.querySelector('[data-food-track]');
        if (t && x) t.scrollLeft = x;
      }

      function currentPct() {
        var card = live.querySelector('[data-cart-progress]');
        return card ? card.getAttribute('data-pct') : null;
      }

      // Pull the freshly-rendered drawer body out of a Section Rendering API response
      // and swap it into the live region, re-rendering the list + footer (and flipping
      // empty/filled).
      function applyBody(html, count) {
        // The change.js `sections` payload wraps the section render in a
        // <div id="shopify-section-…"> wrapper. Pull the bare [data-cart-body]
        // fragment out so it stays a direct child of the live region — otherwise
        // the extra wrapper breaks the `.u-cartdrawer__live > [data-cart-body]`
        // flex rule and the body loses its full-height layout (stray padding /
        // shift after a quantity change).
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-body]');
        preserveRecs(fresh);
        var prevPct = currentPct();
        var prevFood = foodScroll();
        var prevList = listScroll();
        live.innerHTML = fresh ? fresh.outerHTML : html;
        restoreListScroll(prevList);
        animateProgress(prevPct);
        restoreFoodScroll(prevFood);
        live.setAttribute('data-cart-state', count > 0 ? 'filled' : 'empty');
        bindImages(live);
        bind();
      }

      function syncCount(count) {
        // Keep the navbar bag badge in step with the cart.
        document.querySelectorAll('.u-bag__count').forEach(function (b) {
          b.textContent = count; b.setAttribute('data-count', count);
        });
      }

      function change(line, quantity, row) {
        busy = true;
        live.setAttribute('aria-busy', 'true');
        if (row) row.setAttribute('data-busy', '');
        fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity, sections: 'ultreia-cart-drawer-body' })
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            syncCount(state.item_count);
            var html = state.sections && state.sections['ultreia-cart-drawer-body'];
            if (html != null) applyBody(html, state.item_count);
            else window.location.reload();
            // Let the cart page / product cards re-evaluate against the new cart.
            document.dispatchEvent(new CustomEvent('ultreia:cart:change', { detail: { cart: state, source: 'cart-drawer' } }));
          })
          .catch(function () { window.location.href = cartUrl; })
          .finally(function () { busy = false; live.removeAttribute('aria-busy'); });
      }

      function bind() {
        live.querySelectorAll('[data-cart-item]').forEach(function (row) {
          var line = parseInt(row.getAttribute('data-line'), 10);
          var input = row.querySelector('[data-qty-input]');
          var dec = row.querySelector('[data-dec]');
          var inc = row.querySelector('[data-inc]');
          var rawMax = row.getAttribute('data-max');
          var max = rawMax === null ? Infinity : parseInt(rawMax, 10);

          // Removal (trash, "−" at 1, or a typed 0): collapse + slide the row out,
          // then fire the change once it's gone.
          function removeRow() {
            busy = true;
            live.setAttribute('aria-busy', 'true');
            var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var collapseMs = reduceMotion ? 150 : 280;
            row.style.maxHeight = row.offsetHeight + 'px';
            void row.offsetHeight;
            requestAnimationFrame(function () {
              row.setAttribute('data-removing', '');
              row.style.maxHeight = '0px';
            });
            setTimeout(function () { change(line, 0, row); }, collapseMs);
          }

          if (dec) dec.addEventListener('click', function () {
            if (busy) return;
            var next = Math.max(0, parseInt(input.value, 10) - 1);
            if (next === 0) { removeRow(); return; }
            input.value = next;
            change(line, next, row);
          });
          if (inc) inc.addEventListener('click', function () {
            if (busy || inc.hasAttribute('disabled')) return;
            var next = Math.min(max, parseInt(input.value, 10) + 1);
            if (next === parseInt(input.value, 10)) return;
            input.value = next;
            change(line, next, row);
          });
          if (input) input.addEventListener('change', function () {
            if (busy) return;
            var next = Math.min(max, Math.max(0, parseInt(input.value, 10) || 0));
            if (next === 0) { removeRow(); return; }
            input.value = next;
            change(line, next, row);
          });

          var remove = row.querySelector('[data-remove]');
          if (remove) remove.addEventListener('click', function (e) {
            e.preventDefault();
            if (busy) return;
            removeRow();
          });
        });

        loadRecs();
        window.ultreiaFoodStrip(live);
      }

      // "Agregale a la mochila" strip, with two tabs over the Recommendations API:
      //   · "Va con esto" → intent=complementary (curated go-withs)
      //   · "Similares"   → intent=related       (algorithmic similars)
      // The API serves one intent per request, so we fetch both in parallel (seeded
      // from the first cart line, excluding products already in the cart) and assemble
      // the tabbed shell here; the recs section renders only each intent's cards track.
      // Refetched only when the seed changes, so a quantity tweak doesn't re-pull.
      var RECS_TABS = [
        { intent: 'related', label: I18N.recsSimilar },
        { intent: 'complementary', label: I18N.recsComplementary }
      ];
      var RECS_DEFAULT = 'related'; // active tab on first paint

      function recsFetch(seed, exclude, intent) {
        var url = recsUrl
          + '?section_id=ultreia-cart-drawer-recs'
          + '&product_id=' + encodeURIComponent(seed)
          + '&intent=' + intent
          + '&exclude=' + encodeURIComponent(exclude);
        return fetch(url, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (html == null) return null;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var track = doc.querySelector('[data-cart-recs] .u-cdrec__track');
            return track ? track.outerHTML : null; // null when the intent had nothing usable
          })
          .catch(function () { return null; });
      }

      function loadRecs() {
        var host = live.querySelector('[data-cart-recs-host]');
        var body = live.querySelector('[data-cart-body]');
        if (!host || !body || !recsUrl) return;
        var seed = body.getAttribute('data-recs-seed');
        var exclude = body.getAttribute('data-recs-exclude') || '';
        if (!seed) { host.innerHTML = ''; recsSeed = null; return; }
        if (seed === recsSeed && host.querySelector('.u-cdrec')) return; // already shown for this seed
        recsSeed = seed;

        Promise.all(RECS_TABS.map(function (t) { return recsFetch(seed, exclude, t.intent); }))
          .then(function (tracks) {
            // Bail if the host was replaced or the seed moved on while fetching.
            var liveHost = live.querySelector('[data-cart-recs-host]');
            if (!liveHost || recsSeed !== seed) return;

            // Pair each tab with its fetched track; keep only the ones with content.
            var avail = RECS_TABS
              .map(function (t, i) { return { intent: t.intent, label: t.label, track: tracks[i] }; })
              .filter(function (t) { return t.track; });
            if (!avail.length) { liveHost.innerHTML = ''; return; }

            // Default tab if present, else the first available one.
            var hasDefault = avail.some(function (t) { return t.intent === RECS_DEFAULT; });
            var active = hasDefault ? RECS_DEFAULT : avail[0].intent;

            var tabsHtml = avail.length > 1
              ? '<div class="u-cdrec__tabs" role="tablist">' + avail.map(function (t) {
                  var on = t.intent === active;
                  return '<button type="button" class="u-cdrec__tab' + (on ? ' is-active' : '') + '"'
                    + ' role="tab" aria-selected="' + on + '" data-recs-tab="' + t.intent + '">'
                    + t.label + '</button>';
                }).join('') + '</div>'
              : '';

            var panelsHtml = avail.map(function (t) {
              var on = t.intent === active;
              return '<div class="u-cdrec__panel" role="tabpanel" data-recs-panel="' + t.intent + '"'
                + (on ? '' : ' hidden') + '>' + t.track + '</div>';
            }).join('');

            liveHost.innerHTML =
              '<div class="u-cdrec">'
              + '<p class="u-cdrec__title"><span class="u-cdrec__title-plus" aria-hidden="true">+</span> ' + I18N.recsTitle + '</p>'
              + tabsHtml + panelsHtml
              + '</div>';

            bindRecsTabs(liveHost);
          });
      }

      // Tab switching: toggle the active button + show the matching panel. Panels are
      // all pre-fetched, so switching is instant (no network).
      function bindRecsTabs(scope) {
        var tabs = scope.querySelectorAll('[data-recs-tab]');
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var intent = tab.getAttribute('data-recs-tab');
            scope.querySelectorAll('[data-recs-tab]').forEach(function (t) {
              var on = t === tab;
              t.classList.toggle('is-active', on);
              t.setAttribute('aria-selected', on);
            });
            scope.querySelectorAll('[data-recs-panel]').forEach(function (p) {
              p.hidden = p.getAttribute('data-recs-panel') !== intent;
            });
          });
        });
      }

      bindImages(live);
      bind();

      // When the cart changes elsewhere (cart page stepper, quick-shop variant edit),
      // pull a fresh drawer body so the list stays in sync. Ignore our own changes
      // (already applied above) to avoid a redundant fetch.
      document.addEventListener('ultreia:cart:change', function (e) {
        if (e.detail && e.detail.source === 'cart-drawer') return;
        refresh();
      });

      // Adding a product (PDP / quick-shop dispatch ultreia:cart:add) refreshes the
      // list so it's current whenever the shopper opens the drawer. It does NOT
      // pop the drawer open — the toast is the "added to bag" confirmation, and
      // interrupting with the drawer got in the way of browsing.
      document.addEventListener('ultreia:cart:add', function () {
        refresh();
      });

      // Pull fresh contents from the server without going through a change: a cart.js
      // call for the authoritative item count (badge + empty/filled state) plus a
      // Section Rendering API GET for the freshly-rendered body. Used when the cart
      // changes elsewhere (cart page, quick-shop) or after an add-to-cart.
      function refresh() {
        Promise.all([
          fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; }),
          fetch(cartUrl + '?section_id=ultreia-cart-drawer-body', { headers: { Accept: 'text/html' } })
            .then(function (r) { return r.ok ? r.text() : null; })
            .catch(function () { return null; })
        ]).then(function (res) {
          var state = res[0];
          var html = res[1];
          if (state) syncCount(state.item_count);
          if (html == null) return;
          // The section endpoint returns the section's render — our [data-cart-body]
          // fragment. Swap it in and re-bind.
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-body]');
          if (!fresh) return;
          preserveRecs(fresh);
          var prevPct = currentPct();
          var prevFood = foodScroll();
          var prevList = listScroll();
          live.innerHTML = fresh.outerHTML;
          restoreListScroll(prevList);
          animateProgress(prevPct);
          restoreFoodScroll(prevFood);
          if (state) live.setAttribute('data-cart-state', state.item_count > 0 ? 'filled' : 'empty');
          bindImages(live);
          bind();
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ultreia-map-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.querySelector('[data-ultreia-map-drawer]');
    if (!drawer || drawer.dataset.mapDrawerInit) return;
    drawer.dataset.mapDrawerInit = '1';

    var panel  = drawer.querySelector('.u-mapdrawer__panel');
    var body   = drawer.querySelector('.u-mapdrawer__body');
    var hero   = drawer.querySelector('.u-mapdrawer__hero');
    var elCoord = drawer.querySelector('[data-map-coord]');
    var elLoc   = drawer.querySelector('[data-map-loc]');
    var elLocText = drawer.querySelector('[data-map-loc] .u-mapdrawer__loc-eb') || elLoc;
    var elName  = drawer.querySelector('[data-map-name]');
    var elDesc  = drawer.querySelector('[data-map-desc]');
    var elActs  = drawer.querySelector('[data-map-acts]');
    var elSeason  = drawer.querySelector('[data-map-season]');
    var elLevel   = drawer.querySelector('[data-map-level]');
    var elTerrain = drawer.querySelector('[data-map-terrain]');
    var prodHost  = drawer.querySelector('[data-map-products-host]');
    var ctaHost   = drawer.querySelector('[data-map-cta]');
    var ctaBtn    = drawer.querySelector('[data-map-cta] a');

    // Hide the "ver todos" CTA when there are no products to show (the injected
    // section renders [data-map-empty] in that case).
    function syncCta() {
      if (!ctaHost) return;
      var hasProducts = !!prodHost.querySelector('.u-pcard') &&
                        !prodHost.querySelector('[data-map-empty]');
      ctaHost.hidden = !hasProducts;
    }

    var collectionUrl  = drawer.getAttribute('data-collection-url') || '/collections/tienda';
    var filterKey      = drawer.getAttribute('data-filter-key') || 'filter.p.m.shipturtle.sp_6a36faf0d7082';
    var productsSection = drawer.getAttribute('data-products-section') || 'ultreia-map-drawer-products';

    function fmtLL(lat, lng) {
      return Math.abs(lat).toFixed(3) + '°' + (lat < 0 ? 'S' : 'N') + ' · ' +
             Math.abs(lng).toFixed(3) + '°' + (lng < 0 ? 'W' : 'E');
    }

    // A spot's activities, primary first (falls back to the single `activity`).
    function spotActivities(d) {
      var acts = (d.activities && d.activities.length) ? d.activities : (d.activity ? [d.activity] : []);
      return acts.filter(Boolean);
    }

    // Tienda URL filtered by ALL of a place's activities. Repeating the filter
    // key ORs them, so the destination collection shows the same merged set the
    // drawer's product list does. No activities → the bare collection.
    function shopUrl(d) {
      var acts = spotActivities(d);
      if (!acts.length) return collectionUrl;
      return collectionUrl + '?' +
        acts.map(function (a) { return filterKey + '=' + encodeURIComponent(a); }).join('&');
    }

    function fill(d) {
      var acc = d.color || '#1a1a1a';
      // Theme the panel AND the shared snippets (eyebrow/button read --accent).
      if (panel) panel.style.setProperty('--map-acc', acc);
      if (body) body.style.setProperty('--accent', acc);
      // Hero background = the biome's photo (falls back to the accent gradient).
      if (hero) {
        if (d.biomeImg) hero.style.setProperty('--hero-img', 'url("' + d.biomeImg + '")');
        else hero.style.removeProperty('--hero-img');
      }
      elCoord.textContent = (typeof d.lat === 'number' && typeof d.lng === 'number') ? fmtLL(d.lat, d.lng) : '';
      if (d.loc) { elLocText.textContent = d.loc; elLoc.hidden = false; } else { elLoc.hidden = true; }
      elName.textContent = d.name || '';
      elDesc.textContent = d.blurb || '';
      // Activities as chips (primary first, uniform style).
      if (elActs) {
        var acts = spotActivities(d);
        elActs.innerHTML = '';
        acts.forEach(function (a) {
          var li = document.createElement('li');
          li.className = 'u-mapdrawer__chip';
          li.textContent = a;
          elActs.appendChild(li);
        });
        elActs.hidden = !acts.length;
      }
      elSeason.textContent  = d.season || '';
      elLevel.textContent   = d.level || '';
      elTerrain.textContent = d.terrain || '';
      // Point the Shop CTA at the tienda collection filtered by ALL of this
      // place's activities, so it mirrors the product list above. Repeating the
      // filter key ORs them (…?key=Kayak&key=Paddle). With no activities, link
      // to the bare collection.
      if (ctaBtn) ctaBtn.href = shopUrl(d);
    }

    // Blank every slot so a re-open doesn't flash the previous marker's content
    // while fill()/loadProducts() are still resolving. Runs on close.
    function clear() {
      ++reqToken; // invalidate any in-flight products fetch
      if (panel) panel.style.removeProperty('--map-acc');
      if (body) body.style.removeProperty('--accent');
      if (hero) hero.style.removeProperty('--hero-img');
      elCoord.textContent = '';
      elLocText.textContent = ''; elLoc.hidden = true;
      elName.textContent = '';
      elDesc.textContent = '';
      if (elActs) { elActs.innerHTML = ''; elActs.hidden = true; }
      elSeason.textContent = '';
      elLevel.textContent = '';
      elTerrain.textContent = '';
      if (ctaBtn) ctaBtn.href = collectionUrl;
      prodHost.innerHTML = '';
      prodHost.setAttribute('aria-busy', 'false');
      syncCta();
    }

    function open() { drawer.dispatchEvent(new CustomEvent('ultreia:drawer:open', { bubbles: true })); }
    function isOpen() { return drawer.getAttribute('data-open') === 'true'; }

    // Fetch the products whose activity metafield matches this marker, via the
    // Section Rendering API, and inject the rendered cards. A place can have
    // several activities; repeating the filter key ORs them, so Shopify returns
    // the merged, de-duped union in one request. A monotonically increasing token
    // guards against a slower earlier request overwriting a newer one when markers
    // are clicked in quick succession.
    var reqToken = 0;
    function loadProducts(activities) {
      var token = ++reqToken;
      prodHost.setAttribute('aria-busy', 'true');
      var acts = (activities || []).filter(Boolean);
      if (!acts.length) { prodHost.innerHTML = ''; prodHost.setAttribute('aria-busy', 'false'); syncCta(); return; }
      var url = collectionUrl + '?' +
        acts.map(function (a) { return filterKey + '=' + encodeURIComponent(a); }).join('&') +
        '&section_id=' + encodeURIComponent(productsSection);
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (token !== reqToken) return; // a newer click superseded this one
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-map-products]');
          prodHost.innerHTML = fresh ? fresh.outerHTML : '';
          prodHost.setAttribute('aria-busy', 'false');
          syncCta();
        })
        .catch(function () {
          if (token !== reqToken) return;
          prodHost.innerHTML = '';
          prodHost.setAttribute('aria-busy', 'false');
          syncCta();
        });
    }

    // Tell the map (in the iframe) to drop its selected-pin state when we close.
    // The header engine flips data-open to "false"; observe that and notify.
    function notifyDeselect() {
      document.querySelectorAll('[data-ult-map-iframe]').forEach(function (f) {
        if (f.contentWindow) f.contentWindow.postMessage({ type: 'ultreia:map:deselect' }, '*');
      });
    }
    new MutationObserver(function () {
      if (!isOpen()) { notifyDeselect(); clear(); }
    }).observe(drawer, { attributes: true, attributeFilter: ['data-open'] });

    // The iframe map posts the clicked spot out to us. Accept only our own
    // message shape; ignore anything else on the channel.
    window.addEventListener('message', function (e) {
      var msg = e.data;
      if (!msg || msg.type !== 'ultreia:map:spot' || !msg.spot) return;
      fill(msg.spot);
      // The place's full activity set (primary first); ORed into one product query.
      loadProducts(spotActivities(msg.spot));
      open();
      // Let the global notifications runtime raise a toast (it listens for this
      // rather than us reaching into it, same as the cart / trip drawer).
      document.dispatchEvent(new CustomEvent('ultreia:map:spot:open', {
        detail: { spot: msg.spot.name || '' }
      }));
    });

    // Deep-links on the map page:
    //   ?biome=<costa|sierra|cumbre|ruta>  → pre-filter the map to that biome
    //   ?place=<name>                      → fly to one marker and open its drawer
    // The map runs in an opaque-origin srcdoc iframe and can't read our URL, so we
    // read it here and post the value in. We post on each iframe's load (the map
    // applies it once its panel is built; a pre-build arrival is stashed). ?place=
    // wins when both are present — selecting a place resets the biome filter anyway.
    (function deepLinkMap() {
      var params, biome = null, place = null;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      biome = params.get('biome');
      place = params.get('place');
      if (biome) biome = biome.toLowerCase().trim();
      if (place) place = place.trim();
      if (!biome && !place) return;
      function post(f) {
        if (!f || !f.contentWindow) return;
        if (place) f.contentWindow.postMessage({ type: 'ultreia:map:place', place: place }, '*');
        else f.contentWindow.postMessage({ type: 'ultreia:map:biome', biome: biome }, '*');
      }
      document.querySelectorAll('[data-ult-map-iframe]').forEach(function (f) {
        post(f);                              // already-loaded iframe
        f.addEventListener('load', function () { post(f); });  // and on (re)load
      });
    })();

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ultreia-map-trip-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var drawer = document.querySelector('[data-ultreia-trip-drawer]');
    if (!drawer || drawer.dataset.tripDrawerInit) return;
    drawer.dataset.tripDrawerInit = '1';

    var panel  = drawer.querySelector('.u-tripdrawer__panel');
    var body   = drawer.querySelector('.u-tripdrawer__body');
    var hero   = drawer.querySelector('.u-tripdrawer__hero');
    var elCoord   = drawer.querySelector('[data-trip-dates]');
    var elOperator     = drawer.querySelector('[data-trip-operator]');
    var elOperatorText = drawer.querySelector('[data-trip-operator] .u-tripdrawer__loc-eb') || elOperator;
    var elName    = drawer.querySelector('[data-trip-name]');
    var elNote    = drawer.querySelector('[data-trip-datesnote]');
    var elDesc    = drawer.querySelector('[data-trip-desc]');
    var elDuration = drawer.querySelector('[data-trip-duration]');
    var elFormat   = drawer.querySelector('[data-trip-format]');
    var elPrice    = drawer.querySelector('[data-trip-price]');
    var elGallery  = drawer.querySelector('[data-trip-gallery]');
    var elFormatBlurb = drawer.querySelector('[data-trip-format-blurb]');
    var elCert     = drawer.querySelector('[data-trip-cert]');
    var elItinWrap = drawer.querySelector('[data-trip-itinerary-wrap]');
    var elItin     = drawer.querySelector('[data-trip-itinerary]');
    var elIncWrap  = drawer.querySelector('[data-trip-includes-wrap]');
    var elInc      = drawer.querySelector('[data-trip-includes]');
    var elExcWrap  = drawer.querySelector('[data-trip-excludes-wrap]');
    var elExc      = drawer.querySelector('[data-trip-excludes]');
    var elAddonsWrap = drawer.querySelector('[data-trip-addons-wrap]');
    var elAddons   = drawer.querySelector('[data-trip-addons]');
    var elPriceWrap = drawer.querySelector('[data-trip-pricing-wrap]');
    var elPricing  = drawer.querySelector('[data-trip-pricing]');
    var prodHost   = drawer.querySelector('[data-trip-products-host]');
    var shopCta    = drawer.querySelector('[data-trip-shop-cta]');
    var shopCtaBtn = drawer.querySelector('[data-trip-shop-cta] a');
    var contactCta = drawer.querySelector('[data-trip-contact-cta]');

    var collectionUrl   = drawer.getAttribute('data-collection-url') || '/collections/tienda';
    var filterKey        = drawer.getAttribute('data-filter-key') || 'filter.p.m.shipturtle.sp_6a36faf0d7082';
    var productsSection  = drawer.getAttribute('data-products-section') || 'ultreia-map-drawer-products';
    var whatsappLabel = drawer.getAttribute('data-label-whatsapp-cta') || 'Escríbenos por WhatsApp';
    var dayLabel = drawer.getAttribute('data-label-day') || 'Día';
    var waTrackingUrl = drawer.getAttribute('data-wa-tracking-url') || '';

    function tripRefCode() {
      return 'UL-' + Date.now().toString(36).toUpperCase().slice(-4) + Math.random().toString(36).slice(2, 5).toUpperCase();
    }

    function trackWaClick(info) {
      if (!waTrackingUrl) return;
      try {
        fetch(waTrackingUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(info)
        });
      } catch (err) {}
    }

    function syncShopCta() {
      if (!shopCta) return;
      var hasProducts = !!prodHost.querySelector('.u-pcard') && !prodHost.querySelector('[data-trip-empty]');
      shopCta.hidden = !hasProducts;
    }

    function fillList(el, wrap, items, render) {
      if (!el) return;
      el.innerHTML = '';
      items = items || [];
      items.forEach(function (item) { el.appendChild(render(item)); });
      if (wrap) wrap.hidden = !items.length;
    }

    function li(text) {
      var elLi = document.createElement('li');
      elLi.textContent = text;
      return elLi;
    }

    function row(label, price, note) {
      var elLi = document.createElement('li');
      elLi.className = 'u-tripdrawer__row';
      var left = document.createElement('span');
      left.className = 'u-tripdrawer__row-label';
      left.textContent = label || '';
      if (note) {
        var small = document.createElement('span');
        small.className = 'u-tripdrawer__row-note';
        small.textContent = note;
        left.appendChild(small);
      }
      var right = document.createElement('span');
      right.className = 'u-tripdrawer__row-price';
      right.textContent = price || '';
      elLi.appendChild(left);
      elLi.appendChild(right);
      return elLi;
    }

    function fill(d) {
      var acc = d.color || '#1a1a1a';
      if (panel) panel.style.setProperty('--trip-acc', acc);
      if (body) body.style.setProperty('--accent', acc);
      if (hero) {
        if (d.hero) hero.style.setProperty('--hero-img', 'url("' + d.hero + '")');
        else hero.style.removeProperty('--hero-img');
      }
      elCoord.textContent = [d.dates, d.loc].filter(Boolean).join(' · ');
      if (d.operator) { elOperatorText.textContent = d.operator; elOperator.hidden = false; } else { elOperator.hidden = true; }
      elName.textContent = d.name || '';
      if (d.datesNote) { elNote.textContent = d.datesNote; elNote.hidden = false; } else { elNote.hidden = true; }
      elDesc.textContent = d.blurb || '';
      elDuration.textContent = d.duration || '—';
      elFormat.textContent = d.format || '—';
      elPrice.textContent = d.price_from || '—';

      fillList(elGallery, elGallery, d.gallery, function (src) {
        var elLi = document.createElement('li');
        var img = document.createElement('img');
        img.src = src; img.alt = d.name || '';
        img.loading = 'lazy';
        elLi.appendChild(img);
        return elLi;
      });

      if (d.formatBlurb) { elFormatBlurb.textContent = d.formatBlurb; elFormatBlurb.hidden = false; } else { elFormatBlurb.hidden = true; }
      if (d.certBlurb) { elCert.textContent = d.certBlurb; elCert.hidden = false; } else { elCert.hidden = true; }

      fillList(elItin, elItinWrap, d.itinerary, function (day) {
        var elLi = document.createElement('li');
        elLi.className = 'u-tripdrawer__day';
        var imgWrap = document.createElement('div');
        imgWrap.className = 'u-tripdrawer__day-img';
        if (day.img) {
          var img = document.createElement('img');
          img.src = day.img; img.alt = ''; img.loading = 'lazy';
          imgWrap.appendChild(img);
        }
        var text = document.createElement('div');
        var title = document.createElement('p');
        title.className = 'u-tripdrawer__day-title';
        title.innerHTML = '<b>' + dayLabel + ' ' + (day.day != null ? day.day : '') + '</b> · ' + (day.title || '');
        var items = document.createElement('ul');
        items.className = 'u-tripdrawer__day-items';
        (day.items || []).forEach(function (t) { items.appendChild(li(t)); });
        text.appendChild(title);
        text.appendChild(items);
        elLi.appendChild(imgWrap);
        elLi.appendChild(text);
        return elLi;
      });

      fillList(elInc, elIncWrap, d.includes, li);
      fillList(elExc, elExcWrap, d.excludes, li);
      fillList(elAddons, elAddonsWrap, d.addons, function (a) { return row(a.name, a.price, null); });
      fillList(elPricing, elPriceWrap, d.pricing, function (p) { return row(p.label, p.price, p.note); });

      if (shopCtaBtn) shopCtaBtn.href = collectionUrl;

      if (contactCta) {
        contactCta.innerHTML = '';
        var waDigits = (d.contactWhatsapp || d.contactPhone || '').replace(/[^\d]/g, '');
        if (waDigits) {
          var refCode = tripRefCode();
          var waMsg = 'Hola me interesa el viaje "' + (d.name || '') + '"'
            + (d.operator ? ' con ' + d.operator : '') + '. Folio: ' + refCode
            + ' (consérvalo para darle seguimiento a mi reserva).';
          var wa = document.createElement('a');
          wa.className = 'u-btn u-btn--accent';
          wa.href = 'https://wa.me/' + waDigits + '?text=' + encodeURIComponent(waMsg);
          wa.target = '_blank';
          wa.rel = 'noopener';
          wa.textContent = whatsappLabel;
          wa.addEventListener('click', function () {
            trackWaClick({
              viaje: d.name || '',
              operador: d.operator || '',
              codigo: refCode,
              pagina: location.href
            });
            // Let the global notifications runtime raise a toast (it listens
            // for this rather than us reaching into it, same as the cart).
            document.dispatchEvent(new CustomEvent('ultreia:trip:contact', {
              detail: { trip: d.name || '', operator: d.operator || '', code: refCode }
            }));
          });
          contactCta.appendChild(wa);
        }
      }
    }

    function clear() {
      ++reqToken;
      if (panel) panel.style.removeProperty('--trip-acc');
      if (body) body.style.removeProperty('--accent');
      if (hero) hero.style.removeProperty('--hero-img');
      elCoord.textContent = '';
      elOperatorText.textContent = ''; elOperator.hidden = true;
      elName.textContent = '';
      elNote.textContent = ''; elNote.hidden = true;
      elDesc.textContent = '';
      elDuration.textContent = ''; elFormat.textContent = ''; elPrice.textContent = '';
      elGallery.innerHTML = ''; elGallery.hidden = true;
      elFormatBlurb.textContent = ''; elFormatBlurb.hidden = true;
      elCert.textContent = ''; elCert.hidden = true;
      elItin.innerHTML = ''; elItinWrap.hidden = true;
      elInc.innerHTML = ''; elIncWrap.hidden = true;
      elExc.innerHTML = ''; elExcWrap.hidden = true;
      elAddons.innerHTML = ''; elAddonsWrap.hidden = true;
      elPricing.innerHTML = ''; elPriceWrap.hidden = true;
      if (contactCta) contactCta.innerHTML = '';
      prodHost.innerHTML = '';
      prodHost.setAttribute('aria-busy', 'false');
      syncShopCta();
    }

    function open() { drawer.dispatchEvent(new CustomEvent('ultreia:drawer:open', { bubbles: true })); }
    function isOpen() { return drawer.getAttribute('data-open') === 'true'; }

    var reqToken = 0;
    function loadProducts(activities) {
      var token = ++reqToken;
      prodHost.setAttribute('aria-busy', 'true');
      var acts = (activities || []).filter(Boolean);
      if (!acts.length) { prodHost.innerHTML = ''; prodHost.setAttribute('aria-busy', 'false'); syncShopCta(); return; }
      var url = collectionUrl + '?' +
        acts.map(function (a) { return filterKey + '=' + encodeURIComponent(a); }).join('&') +
        '&section_id=' + encodeURIComponent(productsSection);
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (token !== reqToken) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-map-products]');
          if (fresh) {
            fresh.classList.remove('u-mapdrawer__plist');
            fresh.classList.add('u-tripdrawer__plist');
            fresh.removeAttribute('data-map-products');
            fresh.setAttribute('data-trip-products', '');
            var emptyState = fresh.querySelector('[data-map-empty]');
            if (emptyState) { emptyState.removeAttribute('data-map-empty'); emptyState.setAttribute('data-trip-empty', ''); }
          }
          prodHost.innerHTML = fresh ? fresh.outerHTML : '';
          prodHost.setAttribute('aria-busy', 'false');
          syncShopCta();
        })
        .catch(function () {
          if (token !== reqToken) return;
          prodHost.innerHTML = '';
          prodHost.setAttribute('aria-busy', 'false');
          syncShopCta();
        });
    }

    function notifyDeselect() {
      document.querySelectorAll('[data-ult-map-iframe]').forEach(function (f) {
        if (f.contentWindow) f.contentWindow.postMessage({ type: 'ultreia:map:deselect' }, '*');
      });
    }
    new MutationObserver(function () {
      if (!isOpen()) { notifyDeselect(); clear(); }
    }).observe(drawer, { attributes: true, attributeFilter: ['data-open'] });

    window.addEventListener('message', function (e) {
      var msg = e.data;
      if (!msg || msg.type !== 'ultreia:map:trip' || !msg.trip) return;
      fill(msg.trip);
      loadProducts(msg.trip.activities);
      open();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ultreia-pcarousel"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.ultreiaPcarRefresh) return;

    function update(root) {
      var track = root.querySelector('.u-pcar__track');
      if (!track) return;
      var overflow = track.scrollWidth > track.clientWidth + 4;
      root.toggleAttribute('data-overflow', overflow);
      var prev = root.querySelector('[data-pcar-prev]');
      var next = root.querySelector('[data-pcar-next]');
      if (prev) prev.toggleAttribute('data-hidden', track.scrollLeft <= 2);
      if (next) next.toggleAttribute('data-hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
    }

    function refreshAll() {
      document.querySelectorAll('[data-pcar]').forEach(update);
    }
    window.ultreiaPcarRefresh = refreshAll;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pcar-prev], [data-pcar-next]');
      if (!btn) return;
      var root = btn.closest('[data-pcar]');
      var track = root && root.querySelector('.u-pcar__track');
      if (!track) return;
      var card = track.querySelector(':scope > li');
      var step = card ? card.getBoundingClientRect().width : track.clientWidth / 2;
      var dir = btn.hasAttribute('data-pcar-prev') ? -1 : 1;
      track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
    });

    // Scroll events don't bubble, so listen in the capture phase.
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('u-pcar__track')) {
        var root = t.closest('[data-pcar]');
        if (root) update(root);
      }
    }, true);

    window.addEventListener('resize', refreshAll);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refreshAll);
    } else {
      refreshAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ultreia-search-drawer"] && !Shopify.designMode) return;
  try {
    /* Predictive search for the search drawer. Debounced input → /search/suggest.json
     (products only) → render result rows. Reuses the header's generic drawer
     open/close (this element is a [data-ultreia-drawer]); only the fetch/render +
     the [data-search-open] trigger wiring is here. */
  (function () {
    document.querySelectorAll('[data-ultreia-search-drawer]').forEach(function (drawer) {
      if (drawer.dataset.searchInit) return;
      drawer.dataset.searchInit = '1';

      var form = drawer.querySelector('[data-predictive-form]');
      var input = drawer.querySelector('[data-predictive-input]');
      var results = drawer.querySelector('[data-predictive-results]');
      var quicklinks = drawer.querySelector('[data-search-quicklinks]');
      if (!form || !input || !results) return;

      // The quick-filter menu (Hombre/Mujer/Equipo/Todas las actividades) only
      // makes sense before the shopper has typed anything — once there's a
      // query, the predictive results below take over. Swap between the two
      // any time the input's value changes.
      function syncQuicklinks() {
        if (!quicklinks) return;
        quicklinks.hidden = input.value.trim().length > 0;
      }

      // Localized strings rendered onto the drawer root by the markup (Liquid
      // does not execute in a static javascript tag).
      var I18N = {};
      try { I18N = JSON.parse(drawer.getAttribute('data-i18n') || '{}'); } catch (e) {}
      // The "no results" string is a localized template carrying a terms
      // token the JS fills at runtime. Build the literal token via char codes so
      // the source carries no double-brace sequence the linter would treat as Liquid.
      var TERMS_TOKEN = String.fromCharCode(123, 123) + ' terms ' + String.fromCharCode(125, 125);

      var MIN = 2;          // start querying at 2 chars
      var DEBOUNCE = 250;   // ms
      var LIMIT = 8;        // suggestions to show
      var FETCH_LIMIT = 10; // asked for (API max) — LinkedOption dedupe can drop some
      var timer = null;
      var controller = null;
      var moneyFormat = drawer.getAttribute('data-money-format') || '$[amount]';
      // Shopify money_format uses Liquid-style amount tokens; match them generically
      // (amount, amount_with_comma_separator, amount_no_decimals, …) and substitute.
      // Built via RegExp from a string so the source carries no literal Liquid braces.
      var BRACE = String.fromCharCode(123); // {
      var MONEY_TOKEN = new RegExp(BRACE + BRACE + '\\s*[a-z_]+\\s*' + '}}');

      function status(text) {
        results.innerHTML = '<p class="u-searchdrawer__status">' + text + '</p>';
      }
      function clear() { results.innerHTML = ''; }

      function fmtMoney(value) {
        // Predictive Search returns prices as decimal strings (e.g. "24.00"),
        // NOT cents — substitute straight into the shop's money format token.
        var amount = parseFloat(value);
        if (isNaN(amount)) return '';
        amount = amount.toFixed(2);
        if (MONEY_TOKEN.test(moneyFormat)) return moneyFormat.replace(MONEY_TOKEN, amount);
        return moneyFormat.replace('[amount]', amount);
      }

      // Build the full /search results-page URL for a set of terms. We append a
      // prefix wildcard ("*") to each word so the storefront search does the same
      // "starts-with" matching the Predictive Search API does by default — without
      // it, /search only does exact-token matching and returns far fewer results
      // than the drawer ("moch" → "Mochila" matches in the drawer but not on the
      // page). Scoped to products to match the results template.
      function wildcardTerms(terms) {
        return terms.trim().split(/\s+/).map(function (w) {
          // Don't double up a wildcard the user typed themselves.
          return w.charAt(w.length - 1) === '*' ? w : w + '*';
        }).join(' ');
      }
      function searchPageUrl(terms) {
        var base = form.getAttribute('action') || '/search';
        return base + '?q=' + encodeURIComponent(wildcardTerms(terms)) + '&type=product';
      }

      // Request the image from Shopify's CDN at the size we actually display.
      // The Predictive Search API returns the original full-res URL, so without
      // this we'd download a huge image into a 52×58 box. We let the CDN resize via
      // the `width` param (preserves aspect; object-fit: cover handles the crop) and
      // serve a srcset so 1x/2x displays each get an appropriate file. Adds &/?
      // correctly if the URL already carries params, replacing any existing width.
      function sizedImageAt(url, w) {
        if (!url) return url;
        var clean = url.replace(/([?&])width=\d+(&|$)/, function (m, p1, p2) {
          return p2 === '&' ? p1 : (p1 === '?' ? '' : '');
        });
        return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
      }

      function render(products, terms) {
        if (!products.length) {
          // Keep the original curly-quoted terms; the localized template carries
          // a terms token (see TERMS_TOKEN above) we replace with the quoted query.
          status(I18N.noResultsHtml.replace(TERMS_TOKEN, '“' + terms + '”'));
          return;
        }
        var frag = document.createDocumentFragment();
        products.forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'u-searchdrawer__item';
          a.href = p.url;

          // Thumb stage: mirrors the product card's loading treatment — a
          // shimmering placeholder while the image loads, then the image fades in
          // (opacity) once it reports `load`. No image → a static empty stage.
          var img = p.featured_image && p.featured_image.url;
          var stage = document.createElement('span');
          stage.className = 'u-searchdrawer__thumb';
          if (img) {
            stage.className += ' has-img';
            var el = document.createElement('img');
            el.className = 'u-searchdrawer__thumb-img';
            // Default src for the 52px box; srcset lets the browser pick 1x (60px)
            // or 2x (120px) for retina.
            el.src = sizedImageAt(img, 120);
            el.srcset = sizedImageAt(img, 60) + ' 1x, ' + sizedImageAt(img, 120) + ' 2x';
            el.alt = '';
            el.loading = 'lazy';
            el.decoding = 'async';
            el.width = 52; el.height = 58;
            // Fade in on load; clear the shimmer once it's in.
            el.addEventListener('load', function () {
              el.classList.add('is-loaded');
              stage.classList.remove('has-img');
            });
            // Cached images can fire `load` before the listener attaches.
            if (el.complete && el.naturalWidth) {
              el.classList.add('is-loaded');
              stage.classList.remove('has-img');
            }
            stage.appendChild(el);
          } else {
            stage.className += ' u-searchdrawer__thumb--empty';
          }
          a.appendChild(stage);

          var meta = document.createElement('div');
          meta.className = 'u-searchdrawer__meta';
          if (p.vendor) {
            var vendor = document.createElement('span');
            vendor.className = 'u-searchdrawer__vendor';
            vendor.textContent = p.vendor;
            meta.appendChild(vendor);
            // Swap in the real brand + make it link to the tienda filtered by it.
            if (window.UltreiaBrand) window.UltreiaBrand.apply(vendor, p.handle);
          }
          var name = document.createElement('span');
          name.className = 'u-searchdrawer__name';
          name.textContent = p.title;
          meta.appendChild(name);
          if (p._groupLabel) {
            var variants = document.createElement('span');
            variants.className = 'u-searchdrawer__variants';
            variants.textContent = p._groupLabel;
            meta.appendChild(variants);
          }
          a.appendChild(meta);

          var raw = (p.price_min != null) ? p.price_min : p.price;
          var money = fmtMoney(raw);
          if (money) {
            var price = document.createElement('span');
            price.className = 'u-searchdrawer__price';
            // "Desde" when the variants span a price range.
            var varies = p.price_min != null && p.price_max != null &&
              parseFloat(p.price_min) !== parseFloat(p.price_max);
            price.textContent = (varies ? I18N.priceFrom + ' ' : '') + money;
            a.appendChild(price);
          }

          frag.appendChild(a);
        });

        clear();
        results.appendChild(frag);

        // "See all results" → the full /search page for this query. Uses the
        // shared filled primary button (.u-btn, full-width) so it matches CTAs
        // across the theme — not a ghost link.
        var all = document.createElement('a');
        all.className = 'u-btn u-btn--block u-searchdrawer__all';
        all.href = searchPageUrl(terms);
        all.textContent = I18N.viewAllResults;
        results.appendChild(all);
      }

      // Base path for the JSON predictive endpoint: "<search route>/suggest.json".
      // Derive the search route from the form action (locale-aware, since the
      // template renders it from routes.search_url), defaulting to "/search".
      // NOTE: Shopify.routes.predictive_search_url points at the HTML endpoint
      // (/search/suggest), not the .json one, so we don't use it here.
      function searchBase() {
        var action = form.getAttribute('action') || '/search';
        // Strip any trailing slash so we don't produce "/search//suggest.json".
        return action.replace(/\/+$/, '') + '/suggest.json';
      }

      // LinkedOption groups (one product per color, joined by the app): keep only
      // the first product of each group, like the tienda grid does, and tag it
      // with "9 colores". The group comes from the brand-json view, which the
      // rows fetch anyway for the brand (cached per handle). If it's slow, show
      // the results ungrouped rather than keep the shopper waiting.
      var querySeq = 0;
      function dedupeGroups(products) {
        if (!window.UltreiaBrand || !products.length) return Promise.resolve(products);
        var lookups = Promise.all(products.map(function (p) { return window.UltreiaBrand.get(p.handle); }));
        var timeout = new Promise(function (done) { setTimeout(function () { done(null); }, 1500); });
        return Promise.race([lookups, timeout]).then(function (infos) {
          if (!infos) return products;
          var seen = {};
          return products.filter(function (p, i) {
            var g = infos[i] && infos[i].group;
            if (!g) return true;
            if (seen[g]) return false;
            seen[g] = true;
            p._groupLabel = infos[i].groupLabel;
            return true;
          });
        });
      }

      function query(terms) {
        if (controller) controller.abort();
        controller = new AbortController();

        var url = searchBase() +
          '?q=' + encodeURIComponent(terms) +
          '&resources[type]=product' +
          '&resources[limit]=' + FETCH_LIMIT +
          '&resources[options][unavailable_products]=last';

        status(I18N.searching);

        // Safety net: never let the spinner hang forever. If the request hasn't
        // settled in 8s, abort it (→ AbortError) and show the error state.
        var watchdog = setTimeout(function () {
          if (controller) controller.abort();
          status(I18N.timeoutError);
        }, 8000);

        // No custom headers — the .json suffix already forces a JSON response, and
        // adding headers can trigger a CORS preflight that leaves the request hanging.
        fetch(url, { signal: controller.signal })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (data) {
            clearTimeout(watchdog);
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            var mine = ++querySeq;
            return dedupeGroups(products).then(function (list) {
              if (mine !== querySeq) return; // a newer query took over
              render(list.slice(0, LIMIT), terms);
            });
          })
          .catch(function (err) {
            clearTimeout(watchdog);
            if (err.name === 'AbortError') return;
            console.error('[ultreia search] predictive fetch failed:', err, 'url:', url);
            status(I18N.fetchError);
          });
      }

      input.addEventListener('input', function () {
        var terms = input.value.trim();
        syncQuicklinks();
        clearTimeout(timer);
        if (controller) controller.abort();
        if (terms.length < MIN) { clear(); return; }
        timer = setTimeout(function () { query(terms); }, DEBOUNCE);
      });

      // Enter / search button → go to the full /search page, but with the same
      // prefix-wildcard query the drawer uses, so the results match what was shown.
      // (A plain form GET would send the raw "moch" and under-match.)
      form.addEventListener('submit', function (e) {
        var terms = input.value.trim();
        if (!terms) { e.preventDefault(); return; }
        e.preventDefault();
        window.location.href = searchPageUrl(terms);
      });

      // When the drawer opens, focus the input. The header toggles data-open; watch
      // for that transition.
      var mo = new MutationObserver(function () {
        if (drawer.getAttribute('data-open') === 'true') {
          requestAnimationFrame(function () { input.focus(); });
        } else {
          // Reset on close so a re-open starts fresh.
          input.value = '';
          clear();
          syncQuicklinks();
        }
      });
      mo.observe(drawer, { attributes: true, attributeFilter: ['data-open'] });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
